import React, { Component } from 'react';
import ReportHeader from '../../ReportHeader'
import ReportHeader2 from '../../ReportHeader2'
import ReportHeader3 from '../../ReportHeader3'
import LineChart from 'components/custom/Highcharts/Line'
import Section from '../../ReportSection'
import _ from 'lodash'
import { SUBTEST_DATA, TEMP_ERROR } from './constants'
import {
  Table,
  TableHead,
  TableRow,
  TableCell
} from 'react-toolbox'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import ErrorTable from '../ErrorTableEnterprise'
import T from 'i18n-react'
import SuccessStatus from '../../SuccessStatus/index'
import { compose } from 'recompose';
import CustomerInputsTable from '../../CustomerInputsTable'

class ThermalTestEnterpriseGpu extends Component {

  constructor(props) {
    super(props)
    this.state = {
      tdpCurRun: 0,
      tdpMaxCurRun: 0,
      tdpCurSummary: 0,
      tdpMaxCurSummary: 0
    }
  }

  getSummaryTable(run) {
    if (!run) return

    return SUBTEST_DATA.filter(id => run[id] && run[id].length !== 0).map(id => {
      return {
        title: T.translate(`containers.project.nvqualSection.thermalTests.${id}`),
        id: id,
        gpus: run[id].map(x => {
          return {
            name: x.name,
            max: x.max,
            avg: x.avg,
            min: x.min
          }
        })
      }
    })
  }

  renderSummary(subTest, key) {
    return (
      <Table selectable={false}>
        <TableHead key={`head${key}`}>
          <TableCell key={`name${key}`}>Device Name</TableCell>
          <TableCell key={`min${key}`}>Min</TableCell>
          <TableCell key={`avg${key}`}>Average</TableCell>
          <TableCell key={`max${key}`}>Max</TableCell>
        </TableHead>
        {subTest.gpus.map((x, idx) =>
          <TableRow key={`${key}${idx}`}>
            <TableCell key={`name${key}${idx}`}>{x.name}</TableCell>
            <TableCell key={`min${key}${idx}`}>{x.min ? x.min.toFixed(2) : ''}</TableCell>
            <TableCell key={`avg${key}${idx}`}>{x.avg ? x.avg.toFixed(2) : ''}</TableCell>
            <TableCell key={`max${key}${idx}`}>{x.max ? x.max.toFixed(2) : ''}</TableCell>
          </TableRow>
        )}
      </Table>
    )
  }

  renderTGPChart(run, gpuTemp, memTemp) {

    let processed = SUBTEST_DATA.filter(subtest => run[subtest] && run[subtest].length !== 0).map(subtest => {
      return {
        id: subtest,
        title: T.translate(`containers.project.nvqualSection.thermalTests.${subtest}`),
        data: run[subtest]
      }
    })

    return (
      <div styleName="gridWrapper">
        {processed.map((subtest, i) =>
          <div className={styles.chart} key={i}>
            <LineChart title={subtest.title} data={subtest.data} />
          </div>
        )}
      </div>
    )
  }


  onSummaryChangeNormal = (newVal) => {
    this.setState({
      tdpCurSummary: newVal
    })
  }

  onSummaryChangeMax = (newVal) => {
    this.setState({
      tdpMaxCurSummary: newVal
    })
  }

  onRunChangeNormal = (newVal) => {
    this.setState({
      tdpCurRun: newVal
    })
  }

  onRunChangeMax = (newVal) => {
    this.setState({
      tdpMaxCurRun: newVal
    })
  }

  getSummarySource = (summaryTable) =>
    summaryTable.map((x, idx) => {
      return { value: idx, label: x.title }
    })

  getRunSource = (test) =>
    test.runs.map((x, idx) => {
      return { value: idx, label: `Run ${idx + 1}` }
    })


  render() {

    const {
      error,
      files,
      testName,
      onDownloadFile,
      customerInputs,
      testId,
      result
    } = this.props

    const {
      tdpCurRun,
      tdpCurSummary
    } = this.state

    const testData = _.get(this.props, 'data', [])

    const tdpNormalTest = testData.find(test => test.testCategory == 'TDP')

    const curTdpNormal = _.get(tdpNormalTest, `runs[${tdpCurRun}]`, null)

    const summaryNormal = this.getSummaryTable(curTdpNormal)

    const hasErrorData = error && error.length > 0

    return (
      <Section>
        <ReportHeader
          title={T.translate(`containers.project.nvqualSection.test.${testId}`)}
        />
        <Section>
          <ReportHeader2 title={'Summary'} />
          <SuccessStatus result={result} subTestResults={error} />
          {hasErrorData &&
          <Section>
            <ReportHeader2 title={'Error Summary'} />
            <ErrorTable errors={error} />
          </Section>
        }

        </Section>
        <CustomerInputsTable title={'Customer Inputs'}
          showComments
          customerInputs={customerInputs}
          section={testId} />
        {tdpNormalTest && <Section>
          <ReportHeader2 title={`TDP (#${tdpNormalTest.testNum})`}
            showDropdown
            value={tdpCurRun}
            source={this.getRunSource(tdpNormalTest)}
            onChange={this.onRunChangeNormal}
          />
          <Section>
            <ReportHeader3 title={'Test Results'}
              showDropdown
              value={tdpCurSummary}
              source={this.getSummarySource(summaryNormal)}
              onChange={this.onSummaryChangeNormal}
            />
            {this.renderSummary(summaryNormal[tdpCurSummary], 'normal')}
          </Section>
          <Section>
            <ReportHeader3 title={'Graphs'} />
            {this.renderTGPChart(curTdpNormal, tdpNormalTest.gpuTempSpec, tdpNormalTest.memTempSpec)}
          </Section>
        </Section>}
      </Section>
    );
  }
}

const withStyles = CSSModules(styles);
const enhance = compose(withStyles);
export default enhance(ThermalTestEnterpriseGpu);
